import type HttpClient from "../../tastyworks/http"
import {
  PLATFORM_CONFIGURATION_DESER,
  PlatformConfiguration,
} from "../../tastyworks/platform-configuration"

export class PlatformConfigurationService {
  constructor(private readonly httpClient: HttpClient) {}

  readonly show = async (regulatoryDomain: string) =>
    this.httpClient.show(
      new PlatformConfiguration(),
      PLATFORM_CONFIGURATION_DESER.update,
      "regulatory-domains/:regulatoryDomain/platform-configuration",
      { regulatoryDomain }
    )
}
